import { IPutTeeSheetSettings } from "api/rpc/2024-04/facilityAdmin/facility/settings";
import Toggle from "components/form/toggle/Toggle";
import React from "react";
import { useTranslation } from "react-i18next";
import "./facilitySettings.scss";

interface IProps {
  state: Partial<IPutTeeSheetSettings>;
  updateState: <K extends keyof IPutTeeSheetSettings>(key: K, value: IPutTeeSheetSettings[K]) => void;
}

export default function FacilityOnlineStoreSettings(props: IProps) {
  const { state, updateState } = props;
  const { t } = useTranslation();

  return (
    <div className="facility-settings-section p-2">
      <div className="facility-settings-toggle-stack">
        <Toggle
          labelRight={t("All Products category")}
          labelSupport={t("Shows an All Products category on the online store.")}
          onChange={e => updateState("online_store_all_products", e.target.checked)}
          checked={state?.online_store_all_products}
        />
      </div>
    </div>
  );
}
